import { combineReducers } from "redux";
import { actionwareReducer } from "actionware";
import { localizeReducer } from "react-localize-redux";
import { sessionReducer } from "redux-react-session";
import { connectRouter } from "connected-react-router";
import accountReducers from "./views/account/accountReducers";
import accountCreationReducers from "./views/accountCreation/accountCreationReducers";
import historyReducers from "./views/history/historyReducers";
import withdrawalReducers from "./views/withdrawal/withdrawalReducers";
import registrationReducers from "./views/registration/registrationReducers";
import loginReducers from "./views/login/loginReducers";
import profileReducers from "./views/profile/profileReducers";
import lenderStatisticReducers from "./views/lenderStatistic/lenderStatisticReducers";
import resetPasswordReducers from "./views/resetPassword/resetPasswordReducers";
import applicationApprovalReducers from "./views/application/applicationApprovalReducers";
import summaryReducer from "./views/approval/summaryReducers";
import transactionReducers from "./views/transaction/transactionReducers";
import confirmationModalReducers from "./views/confirmationModal/confirmationModalReducers";
import fundingLimitReducers from "./views/fundingLimit/fundingLimitReducers";
import approvalSettingReducer from './views/approvalSetting/approvalSettingReducer';
import lenderRegistrationsReducers from './views/lenderRegistrations/reducer';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    actionware: actionwareReducer,
    localize: localizeReducer,
    session: sessionReducer,
    account: accountReducers,
    accountCreation: accountCreationReducers,
    history: historyReducers,
    withdrawal: withdrawalReducers,
    registration: registrationReducers,
    login: loginReducers,
    profile: profileReducers,
    lenderStatistic: lenderStatisticReducers,
    resetPassword: resetPasswordReducers,
    applicationApproval: applicationApprovalReducers,
    summary: summaryReducer,
    transaction: transactionReducers,
    confirmation: confirmationModalReducers,
    funding: fundingLimitReducers,
    autoApproval: approvalSettingReducer,
    lenderRegistrationPage: lenderRegistrationsReducers
  });

export default createRootReducer;
